itsoftApp.createModule("createObject", function () {
  /* NOTE: Более понятный код (частично на ES6) находится по пути assets/scripts/archive */
  
    var module = this;

    var initWebgl = function () {
        itsoftApp.loadScript("/assets/scripts/threejs/mod-three.js", function () {
            var canvasContainer = document.getElementById("canvas-3d-container");
            var preloader = document.querySelector(".feature__preloader-container");

            if (canvasContainer) {
                var isScroll = canvasContainer.classList.contains("js-scroll");
                var obj;
                var controls;
                var camera, scene, renderer, distanceToCamera;
                var initialWidth = canvasContainer.clientWidth;
                var initialHeight = canvasContainer.clientHeight;
                var degToRadians = (deg) => (deg * Math.PI) / 180;
                init();
                render();

                function init() {
                    distanceToCamera = 3700;

                    var params = {
                        fov: 15,
                        aspect: initialWidth / initialHeight,
                        near: 1,
                        far: 5500
                    };

                      // передаем начальные настройки в камеру
                    camera = new PerspectiveCamera(params.fov, params.aspect, params.near, params.far);

                    camera.position.z = distanceToCamera;

                    scene = new Scene();

                    new RGBELoader()
                    .setDataType( UnsignedByteType )
                    .setPath('/media/3d/textures/')
                    .load('photo-studio.hdr', function (texture) {

                        var envMap = pmremGenerator.fromEquirectangular( texture ).texture;

                        // scene.background = envMap;
                        scene.environment = envMap;

                        texture.dispose();
                        pmremGenerator.dispose();

                        requestAnimationFrame(() => {
                            onEnterFrame();
                        });

                        // NOTE: нужно включить декодер, если модель оптимизирована с помощью Draco
                        
                        // var drLoader = new DRACOLoader();
                        // drLoader.setDecoderPath('/assets/scripts/draco/');
                        // drLoader.setDecoderConfig({type: 'js'});
                        // drLoader.preload();
                        var loader = new GLTFLoader();
                        // loader.setDRACOLoader(drLoader);
                        loader.load('/media/3d/nebulizer_opt_4.1.glb', function (group) {
                            var children = group.scene;
                            obj = group.scene;
                            scene.add( group.scene );
                            // drLoader.dispose();
                            group.scene.children[0].children[0].material.envMapIntensity = 1.4;

                            var infoBlocks = document.querySelectorAll("[data-info]");
                            group.scene.rotation.y = degToRadians(35);

                            var initAnimation = function () {
                                ScrollTrigger.matchMedia({
                                    "(min-width: 320px)": function() {
                                        var modelTimeline = gsap.timeline({
                                            scrollTrigger: {
                                                trigger: ".page__feature-section",
                                                start: "top top",
                                                end: "bottom bottom",
                                                id: "3d-rotate",
                                                scrub: true,
                                                onUpdate: function (self) {
                                                    requestAnimationFrame(() => {
                                                        onEnterFrame();
                                                    });
                                                }
                                              // immediateRender: false
                                            }
                                        });
                                      
                                        modelTimeline.to(group.scene.rotation, {
                                            y: "+=" + degToRadians(360)
                                        });
                                    },

                                    // "(max-width: 1279px)": function() {
                                    //     var mobileModelTimeline = gsap.timeline({
                                    //         scrollTrigger: {
                                    //             trigger: "#feature",
                                    //             start: "top " + itsoftApp.commonVars.headerHeight,
                                    //             end: "bottom bottom",
                                    //             scrub: true,
                                    //             onUpdate: function (self) {
                                    //                 requestAnimationFrame(() => {
                                    //                     onEnterFrame();
                                    //                 });
                                    //             }
                                    //           // immediateRender: false
                                    //         }
                                    //     })

                                    //     mobileModelTimeline.to(group.scene.rotation, {
                                    //         y: "+=" + degToRadians(360)
                                    //     })
                                    // }
                                });
                            };

                            itsoftApp.modules.scrollActions.callback(initAnimation);

                            if (canvasContainer.classList.contains("js-anim")) {
                                // удаляет класс после окончания анимации
                                canvasContainer.classList.remove("js-anim");
                            }
                            preloader.style.display = "none";

                            requestAnimationFrame(() => {
                                onEnterFrame();
                            });
                        });

                    } );

                    var resizeInProgress = false;

                    renderer = new WebGLRenderer( {
                        antialias: true,
                        alpha: true
                    });
                    renderer.setPixelRatio(window.devicePixelRatio);
                    renderer.setSize(initialWidth, initialHeight);
                    renderer.setClearColor(0x000000, 0);
                    renderer.outputEncoding = sRGBEncoding;

                    var pmremGenerator = new PMREMGenerator( renderer );
                    pmremGenerator.compileEquirectangularShader();

                    canvasContainer.appendChild( renderer.domElement );

                    const onEnterFrame = () => {
                        if (resizeInProgress) {
                          resize();
                        }

                        renderer.render(scene, camera);

                        resizeInProgress = false;
                        
                        if (!isScroll) {
                          controls.update();
                        }
                    };

                    if (!isScroll) {
                        controls = new OrbitControls( camera, renderer.domElement );
                        controls.minPolarAngle = Math.PI / 2;
                        controls.maxPolarAngle = Math.PI / 2;
                        controls.enableZoom = false;
                        controls.enableKeys = false;
                        controls.enablePan = false;
                        controls.keys = {
                          LEFT: "",
                          UP: "",
                          RIGHT: "",
                          BOTTOM: ""
                        };
                        controls.addEventListener("change", render);
                    }
                      
                    requestAnimationFrame(() => {
                        onEnterFrame();
                    });
                  
                  //
                  // Resize:
                    resize();
                  
                    window.addEventListener("resize", () => {
                        resizeInProgress = true;
                        requestAnimationFrame(() => {
                            onEnterFrame();
                        });
                    });
                }

                function resize() {
                    const width = canvasContainer.clientWidth;
                    const height = canvasContainer.clientHeight;

                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                  
                    // 3.3. Renderer resize
                    renderer.setSize(width, height);
                }

                //

                function render() {
                    renderer.render(scene, camera);
                }
            }
        });
    };

    module.callback = initWebgl;
});